enum LoadingState {
    None = 1,
    ModalWithVisibleContent,
    ModalWithInvisibleContent,
    NotModalWithInvisibleContent,
    NotModalWithVisibleContent,
    UnexpectedLoadingError
}

export default LoadingState;